<ng-container *transloco="let t">
  <main *ngIf="papCategory$ | async as papCategory; else loading" appPreventCopy>
    <div class="card-wrapper">
      <p>
        <span *ngIf="papCategory | competenceNumber as number" class="competence-number">{{ number }}</span>
        <span>{{ papCategory.name }}</span>
      </p>
    </div>
    <div
      *ngIf="eduActivities$ | async as eduActivities; else loading"
      class="content-container white-container mt-2 d-flex gap-5 flex-wrap flex-md-nowrap"
    >
      <aside class="nav-container">
        <div class="d-flex flex-column gap-2 sticky-nav">
          <div
            (click)="scrollTo(eduActivity.uuid)"
            class="recommendation-nav-item"
            [class.active]="activeUuid === eduActivity.uuid"
            *ngFor="let eduActivity of eduActivities; let i = index"
          >
            {{ i + 1 }}. {{ eduActivity.title }}
          </div>
        </div>
      </aside>
      <div class="d-flex flex-column recommendation-wrap">
        <div class="recommendation-content">
          <div class="pb-2" [id]="eduActivity.uuid" *ngFor="let eduActivity of eduActivities; let i = index">
            <div class="section-title">{{ eduActivity.title }}</div>
            <div [innerHTML]="sanitize(eduActivity.htmlContent)"></div>
          </div>
        </div>
        <div class="info-box d-flex gap-2">
          <div class="icon-wrap">
            <i class="fe fe-info sidemenu_icon"></i>
          </div>

          <div>
            {{ t('recommendationDetail/endText') }}
            <a href="mailto:info@isophi.cz">info&#64;isophi.cz</a>. {{ t('shared/thanks') }}! ❤️
          </div>
        </div>
      </div>
    </div>

    <!-- Recommendations cards -->
    <app-recommendations-cards
      [categories]="currentCategories$ | async"
      variant="compact"
      [title]="t('recommendations/recommendation')"
    ></app-recommendations-cards>
  </main>
  <ng-template #loading>
    <div class="text-center pt-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>
</ng-container>
